import axios from 'axios'
export default{
    host:'',
    GetData(method, pars, callback, errback) {
        let errcn=""
        var authtoken = "Bearer " + this.GetCU().token
        let that = this
        axios.defaults.baseURL = '/api'
        axios({
            url: method,
            method: "get",
            headers: { "Authorization": authtoken },
            params: pars
        }).then(function (res) {
            callback(res)
        }).catch(function (err) {
            if(err.toString().indexOf('401')>=0){
                let curcu = that.CU;
                curcu.pwd = ""
                curcu.token = ""
                that.setItem("currentuser", curcu)
                that.$router.replace("/");
            }else{
                errcn = err.toString().replace('Duplicate entry','数据重复：')
                if(errback)
                    errback(errcn)
            }
        });
    },
    GetCU(){
        let currentuser =JSON.parse(window.localStorage.getItem("currentuser"));
		if (!currentuser)
			currentuser = { token: '', pwd: '', exp: '', cu: { uid:'',uname:'',uclass:'管理员',srid:''} }
		return currentuser
    },
    getlevels(callback){
        let that =this
        that.GetData('Common/GETITEM',{objname:'sys_roles',guidvalue:that.GetCU().cu.srid},function(res){
            window.sessionStorage.setItem('levels',res.data.data.role_rights)
            callback()
        })
    },
    chklevel(path){
        let levels= []
        let tmp = window.sessionStorage.getItem('levels');
        if(!tmp)
            return false;
        try{
            levels = tmp.split(',')
        }catch{
            levels=[]
        }
        if(levels.findIndex(item=>item==path)>=0)
            return true
        else
            return false;
    }
}